import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpService} from './http.service';
import {GetAverageScoreAccumulatorResponseDto} from '../models/GetAverageScoreAccumulatorResponseDto';
import {Subject} from 'rxjs/Subject';
import {HttpResponse} from '@angular/common/http';

@Injectable()
export class AverageScoreAccumulatorsService {
    averageScoreAccumulatorsLoaded: Subject<Array<GetAverageScoreAccumulatorResponseDto>>;

    constructor(private httpService: HttpService) {
        this.averageScoreAccumulatorsLoaded = new Subject();
    }

    getAll(): void {
        const url = environment.ENDPOINTS.GET_ALL_AVERAGE_SCORE_ACCUMULATORS;
        this.httpService.getJson<Array<GetAverageScoreAccumulatorResponseDto>>(url).subscribe(response => {
            this.averageScoreAccumulatorsLoaded.next(response.body);
        });
    }

    getAverageScoreAccumulatorsLoadedSubject() {
        return this.averageScoreAccumulatorsLoaded.asObservable();
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/services/average-score-accumulators.service.ts